export default "__VITE_ASSET__B5D0Yt4V__"